import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import TooltipSection from '../TooltipSection';

export const InventoryTypeTargetingTooltip = () => (
    <TooltipSection>
        <FormattedMessage
            id="campaign.targeting.platform.inventory.type.tooltip"
            defaultMessage="Select 'All' for all traffic, 'WEB' for browsers, or 'APP' for in-app traffic."
        />
    </TooltipSection>
);
